/**
 * Компонент прогресс-бара для batch событий
 */
import React from 'react';
import { Progress, Typography } from 'antd';
import { calculateProgress } from '../utils/eventFormatters';

const { Text } = Typography;

interface EventProgressBarProps {
  completed: number;
  total: number;
  showText?: boolean;
}

export const EventProgressBar: React.FC<EventProgressBarProps> = ({
  completed,
  total,
  showText = true,
}) => {
  const progress = calculateProgress(completed, total);

  return (
    <div>
      <Progress percent={progress} status={progress === 100 ? 'success' : 'active'} />
      {showText && (
        <Text type="secondary">
          Выполнено: {completed} из {total}
        </Text>
      )}
    </div>
  );
};
